import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["errorMessage", "numVersions", "offeringId", "panelBodyHeader", "panelFooter", "panelHeader", "panelSubheader", "renderVersionActions", "versionHistoryQuery"];
import UIDialogueHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogueFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import VersionHistory from './VersionHistory';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function VersionHistoryPanel(_ref) {
  let {
      errorMessage,
      numVersions,
      offeringId,
      panelBodyHeader,
      panelFooter,
      panelHeader,
      panelSubheader,
      renderVersionActions,
      versionHistoryQuery
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(UIModalPanel, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(UIDialogueHeader, {
      children: panelHeader
    }), panelSubheader, /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [panelBodyHeader, /*#__PURE__*/_jsx(VersionHistory, {
        errorMessage: errorMessage,
        numVersions: numVersions,
        offeringId: offeringId,
        renderVersionActions: renderVersionActions,
        versionHistoryQuery: versionHistoryQuery
      })]
    }), /*#__PURE__*/_jsx(UIDialogueFooter, {
      children: panelFooter
    })]
  }));
}